<template>
  <div class="shelf container">
    <div class="shelf-page-bg">
      <span class="shelf-bg-tl"></span>
      <span class="shelf-bg-tr"></span>
    </div>
    <coupon-float :default-collapsed="true" />

    <!--书架骨架图-->
    <div class="book-list" v-if="fetching">
      <div class="shelf-row" v-for="n in 2" :key="'sk-'+n">
        <div class="book skeleton-book" v-for="m in 2" :key="'sk-'+n+'-'+m">
          <div class="book-cover">
            <div class="skeleton-cover skeleton-shimmer"></div>
          </div>
          <div class="book-info">
            <div class="skeleton-line skeleton-title skeleton-shimmer"></div>
            <div class="skeleton-line skeleton-text skeleton-shimmer"></div>
            <div class="skeleton-line skeleton-text short skeleton-shimmer"></div>
            <div class="skeleton-btns">
              <div class="skeleton-btn skeleton-shimmer"></div>
              <div class="skeleton-btn skeleton-shimmer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-else>
      <div class="book-list" v-if="currentList.length">
        <div class="shelf-row" v-for="(row, rowIdx) in shelfRows" :key="rowIdx">
          <template v-for="(item, itemIdx) in row">
            <div v-if="item.__promotion"
                 :key="'promo-' + rowIdx + '-' + itemIdx"
                 class="promotion-slot"
                 @click="checkPromotion">
              <img :src="promotionImages.large" class="promotion-slot__image" alt="">
            </div>
            <book v-else :key="item.bid"
                  @delete="deleteAlbumBook"
                  @empty="showImport = true"
                  :book="item"></book>
          </template>
          <div class="book-placeholder" v-if="row.length < 2"></div>
        </div>
      </div>
      <div v-else class="text-center" style="margin-top: 2rem;">
        <img src="../../../static/images/placeholder/pic_empty.png" width="120" alt="">
        <p>{{$t('shelf.emptyTitle')}}</p>
        <p>{{$t('shelf.emptySubTitle')}}</p>
      </div>
    </template>

    <div class="fb-customerchat"
         :ref="user.uid"
         logged_in_greeting="Hi，有做書問題可以私訊我哦！"
         logged_out_greeting="Hi，有做書問題可以私訊我哦！"
         page_id="104557935331848">
    </div>
    <!--  创建新书弹窗  -->
    <modal :show="showCreateModal" @close="showCreateModal = false">
      <create-book-modal ref="createModal" slot="body"
                         :default-title="user.nickname ? `${user.nickname}'s iPastBook` : 'My iPastBook'"
                         :default-author="user.nickname || ''"
                         :existing-books="shelfList.diarybook"
                         @confirm="onCreateConfirm"
                         @sync-fb="syncFBData"
                         @close="showCreateModal = false"/>
    </modal>
    <!--  选择导入内容  -->
    <modal :show="showImport" @close="showImport = false">
      <content-import slot="body"
                      @ins="startInsAuth"
                      @patch="startPatch"
                      @close="closeImport"
                      @select="selectSource"/>
    </modal>
    <!--  补写书籍内容  -->
    <modal :show="showPatch" class="patch-modal">
      <patch-item ref="patch" slot="body"></patch-item>
      <div class="clearfix" slot="footer">
        <button class="btn plant pull-left" @click="showPatch = false">{{$t('button.cancel')}}</button>
        <button class="btn primary pull-right" @click="savePatchItem">{{$t('button.ok')}}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { cloneDeep, filter, find, findIndex, last, orderBy } from 'lodash'
import api from 'src/api/'
import { track } from 'src/utils/track'
import generateCover from 'src/_utils/generateCover'
import config from 'src/app.config'
import Book from './Book/Book.vue'
import ContentImport from './ContentImport'
import CreateBookModal from './CreateBookModal'
import PatchItem from '../Design/Selection/PatchItem'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'shelf',
  components: {
    Book,
    ContentImport,
    CreateBookModal,
    PatchItem,
    CouponFloat: () => import('../../components/CouponFloat.vue')
  },
  data () {
    return {
      booksData: [],
      dataLoaded: false,
      showModal: false,
      showDialog: false,
      bookEmpty: false,
      fetching: false,
      showCreateModal: false,
      showImport: false,
      showPatch: false,
      uploading: false,
      isNavigating: false,
      activeTab: 'diarybook',
      isCreating: false,
      shelfList: {
        diarybook: [], // 日记书数据
        photobook: [], // 相册书数据
        calendar: [] // 月历
      },
      diaryBookEnable: false
    }
  },
  computed: {
    ...mapGetters([
      'user', 'promotionLoaded', 'promotionImages', 'promotionConf'
    ]),
    tabs () {
      return [
        {
          name: this.$t('shelf.tabDiaryBook'),
          value: 'diarybook'
        },
        {
          name: this.$t('shelf.tabPhotoBook'),
          value: 'photobook'
        }
      ]
    },
    currentList () {
      return this.shelfList[this.activeTab]
    },
    shelfRows () {
      const rows = []
      const books = this.currentList || []
      const list = []
      if (this.promotionLoaded && books.length) {
        list.push({ __promotion: true })
      }
      list.push(...books)
      for (let i = 0; i < list.length; i += 2) {
        rows.push(list.slice(i, i + 2))
      }
      return rows
    }
  },
  created () {
    this.fetchBooks()
    this.$root.$on('create-book', this.createBook)
    this.maybeFinalizeStripePayment()
    this.maybeAnnounceFbConnected()
    // GA4 漏斗：进入书架（view_item_list）
    try { track('view_item_list', { item_list_id: 'shelf', item_list_name: 'Shelf' }) } catch (e) {}
  },
  beforeDestroy () {
    this.$root.$off('create-book', this.createBook)
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    checkPromotion () {
      window.location.href = this.promotionConf.introLink
    },
    // 从 FB connect 回来时后端在 hash 里塞结果标识：
    //   fb_connected → 成功（含共享模式）：loading → fetchBooks → toast
    //   fb_* 其他 → 失败 toast
    async maybeAnnounceFbConnected () {
      const hash = (window.location.hash || '').replace(/^#/, '')
      if (!hash.startsWith('fb_')) return
      // 清 hash 避免刷新重复触发
      history.replaceState(null, '', window.location.pathname + window.location.search)
      if (hash === 'fb_connected') {
        this.setLoading({
          text: this.$t('shelf.fbConnectedToast') || 'Facebook connected — importing your posts…',
          visible: true
        })
        await new Promise(resolve => setTimeout(resolve, 800))
        try {
          await this.fetchBooks()
        } finally {
          this.setLoading(false)
        }
        this.$toast({
          message: this.$t('shelf.fbConnectedToast') || 'Facebook connected — importing your posts…',
          position: 'bottom'
        })
        return
      }
      this.$toast({
        message: this.$t('shelf.fbConnectError') || 'Facebook connection failed, please try again.',
        position: 'bottom'
      })
    },
    // Stripe 付款成功后 Stripe 会带 ?type=stripe&order_id&session_id 回到书架。
    // 调 verify 让后端 1) 查 Stripe 确认付款 2) 把 Order.paid 更新到 DB。
    // 处理完清掉 query，toast 提示，刷新列表以拿到最新订单状态。
    async maybeFinalizeStripePayment () {
      const { type, order_id: orderId, session_id: sessionId } = this.$route.query || {}
      if (type !== 'stripe' || !orderId || !sessionId) return
      try {
        const data = await api.verifyStripeCheckout(sessionId, orderId)
        const paid = data && (data.paid || data.dbPaid)
        this.$toast({
          message: paid
            ? this.$t('checkout.paymentSuccess') || 'Payment successful'
            : this.$t('checkout.paymentPending') || 'Payment pending — refresh in a moment',
          position: 'bottom'
        })
      } catch (e) {
        this.$toast({
          message: this.$t('checkout.paymentVerifyFailed') || 'Could not verify payment. Check your orders.',
          position: 'bottom'
        })
      } finally {
        // remove stripe params from URL to avoid re-triggering on refresh
        const query = Object.assign({}, this.$route.query)
        delete query.type
        delete query.order_id
        delete query.session_id
        this.$router.replace({ path: this.$route.path, query })
        this.fetchBooks()
      }
    },
    deleteAlbumBook (book) {
      if (this.activeTab === 'diarybook' && this.shelfList.diarybook.length <= 1) {
        this.$confirm({
          title: this.$t('shelf.deleteMinError'),
          cancel: false
        })
        return
      }
      this.$confirm({
        title: this.$t('shelf.deleteConfirm'),
        onOk: (modal) => {
          modal.close()
          const bookDeleteHandler = {
            diarybook: api.deleteDiaryBook,
            photobook: api.deletePhotoBook,
            calendar: api.deleteCalendar
          }
          const tab = this.activeTab || 'diarybook'
          const request = bookDeleteHandler[tab]
          request(book.bid).then(data => {
            if (data.errors) {
              this.$toast({
                message: this.$t('shelf.deleteFailed')
              })
              return
            }
            const books = cloneDeep(this.shelfList[tab])
            const currentIndex = findIndex(books, { bid: book.bid })
            books.splice(currentIndex, 1)
            this.shelfList[tab] = books
            this.$toast({
              message: this.$t('shelf.deleted')
            })
          })
        }
      })
    },
    createBook () {
      this.showCreateModal = true
    },
    syncFBData () {
      const book = this.shelfList.diarybook.find(b => b.source && b.postsInitialized)
      if (!book) return
      const { uid } = this.user
      const link = `${config.facebookLoginPath}?uid=${uid}&bid=${book.bid}&source=posts`
      window.location.href = link
    },
    async onCreateConfirm ({ title, author, selectedSources }) {
      this.showCreateModal = false
      try {
        this.isCreating = true
        this.setLoading({ text: this.$t('shelf.creating'), visible: true })

        // 1. 创建书
        const data = await api.createDiaryBook()
        if (data.errors) {
          this.$toast({ message: this.$t('shelf.exceeded') })
          return
        }
        const bid = data.bid
        const { uid } = this.user
        const bookSource = data.source || data.currentChapters

        // 3. 根据来源处理
        const needFBOAuth = selectedSources.includes('facebook-auth')
        const hasFB = selectedSources.includes('facebook')
        const hasPatch = selectedSources.includes('patch')
        const hasUpload = selectedSources.includes('upload')

        if (needFBOAuth) {
          // 先设置书名作者，再跳转 OAuth
          try {
            const currentDesign = await api.fetchCoverDesign(bid)
            const design = (currentDesign && !currentDesign.errors) ? currentDesign : (data.design || {})
            design.title = title
            design.author = author
            await api.updateCoverDesign(bid, design)
          } catch (e) {}
          const link = `${config.facebookLoginPath}?uid=${uid}&bid=${bid}&source=posts`
          window.location.href = link
          return
        }

        if (hasFB || hasPatch) {
          // 已有内容 → 全选所有内容，触发排版，回到书架
          try {
            // 全选 FB 内容
            if (hasFB && bookSource) {
              const fbData = await api.fetchSocialInfo(bookSource, 'facebook')
              if (fbData && fbData.facebook) {
                const unchecked = fbData.facebook.unchecked || []
                if (unchecked.length) {
                  const addMonths = unchecked.map(m => m.month)
                  await api.updateSocialBook(bookSource, { facebook: { add: addMonths, remove: [] } })
                }
              }
            }
            // 全选补写内容
            if (hasPatch && bookSource) {
              const patchData = await api.fetchSocialInfo(bookSource, 'patch')
              if (patchData && patchData.patch) {
                const unchecked = patchData.patch.unchecked || []
                if (unchecked.length) {
                  const addMonths = unchecked.map(m => m.month)
                  await api.updateSocialBook(bookSource, { patch: { add: addMonths, remove: [] } })
                }
              }
            }
            // 触发排版
            await api.triggerTypeset(bid)
          } catch (e) {
            console.warn('Content setup error:', e)
          }
          // 最后更新书名和作者（排版后再设置，防止被覆盖）
          try {
            const currentDesign = await api.fetchCoverDesign(bid)
            const design = (currentDesign && !currentDesign.errors) ? currentDesign : (data.design || {})
            design.title = title
            design.author = author
            await api.updateCoverDesign(bid, design)
            data.design = design
          } catch (e) {
            console.warn('Design update error:', e)
          }
          const books = this.handleBooksData([data])
          books.forEach(b => { b.isNew = true })
          this.shelfList.diarybook.unshift(...books)
          this.$toast({ message: this.$t('shelf.created') })
        } else if (hasUpload) {
          // 纯补写新内容 → 跳转到补写页
          // 先设置书名作者
          try {
            const currentDesign = await api.fetchCoverDesign(bid)
            const design = (currentDesign && !currentDesign.errors) ? currentDesign : (data.design || {})
            design.title = title
            design.author = author
            await api.updateCoverDesign(bid, design)
            data.design = design
          } catch (e) {}
          const books = this.handleBooksData([data])
          books.forEach(b => { b.isNew = true })
          this.shelfList.diarybook.unshift(...books)
          this.$router.push({
            name: 'selection',
            query: { bid, sid: bookSource, tab: 'patch' }
          })
        }
      } finally {
        this.isCreating = false
        this.setLoading(false)
      }
    },
    async fetchBooks () {
      try {
        // 设置加载状态
        this.fetching = true

        // 获取数据
        const data = await api.fetchBooks(this.user.uid)

        // 验证数据有效性
        if (!data || data.errors) {
          const errorCode = (data && data.errors && data.errors.code) || ''
          const message = `${this.$t('shelf.tipBookFailed')}${errorCode}`

          this.$toast({
            message,
            position: 'bottom'
          })
          return
        }

        // 解构并更新数据
        const {
          ableToCreateNew,
          books
        } = data
        this.diaryBookEnable = ableToCreateNew
        this.shelfList.diarybook = this.handleBooksData(books)

        // 更新加载状态
        this.dataLoaded = true
      } finally {
        // 重置加载状态
        this.fetching = false
      }
    },
    // 处理书籍数据
    handleBooksData (booksData) {
      booksData.map((item, index) => {
        const months = orderBy(item.currentChapters, ['month'], ['asc'])
        if (months.length) {
          item.startDate = months[0].month.substr(0, 4) + '/' + months[0].month.substr(4, 2)
          item.endDate = last(months).month.substr(0, 4) + '/' + last(months).month.substr(4, 2)
        }
        item.type = 'diarybook'

        try {
          item.retypesetMonths = item.retypesetMonths[item.typeset] ? item.retypesetMonths[item.typeset] : []
          if (item.retypesetMonths.length) {
            item.isTypesetting = true
          }
          item.title = item.design.title
          item.author = item.design.author
          item.coverUrl = generateCover({
            design: item.design,
            chapters: item.currentChapters
          })
          item.template = find(config.templates, { name: item.typeset }).desc
          delete item.deletedChapters
          delete item.currentChapters
        } catch (err) {
          console.error(err)
        }
        return item
      })
      const currentBooks = orderBy(filter(booksData, { editable: true }), ['updatedAt'], ['desc'])
      const finalizeBooks = orderBy(filter(booksData, { editable: false }), ['updatedAt'], ['desc'])
      return currentBooks.concat(finalizeBooks)
    },
    // 删除拉新邀请
    closeImport () {
      this.showImport = false
    },
    selectSource (sources) {
      this.showImport = false
      this.setLoading(true)
      const { bid } = this.currentList[0]
      const { uid } = this.user
      let facebookImportLink = `${config.facebookLoginPath}?uid=${uid}&bid=${bid}`
      facebookImportLink = sources.reduce((total, item) => {
        total = `${total}&source=${item}`
        return total
      }, facebookImportLink)
      window.location.href = facebookImportLink
    },
    startInsAuth () {
      const { bid } = this.currentList[0]
      const { uid } = this.user
      window.location.href = `/social/instagram_data?uid=${uid}&bid=${bid}`
    },
    startPatch () {
      this.showImport = false
      this.showPatch = true
    },
    savePatchItem () {
      if (this.uploading) return
      const {
        content,
        title,
        date,
        time,
        images
      } = this.$refs.patch
      let picList = images.slice()
      picList = picList.map(item => {
        return item[0]
      })
      if (!content && !picList.length) {
        this.$toast({
          message: this.$t('selection.tipCompletedPatch')
        })
        return
      }
      const dateArr = date.split('-')
      if (dateArr[0].length !== 4) {
        this.$toast({
          message: this.$t('selection.tipTimeError')
        })
        return
      }
      const item = {
        title,
        content,
        postDate: `${date}T${time}`,
        picList
      }
      this.$toast({
        message: this.$t('selection.tipSaving'),
        duration: 1000,
        position: 'bottom'
      })
      this.showModal = false
      const {
        source,
        bid
      } = this.currentList[0]
      this.uploading = true
      api.createItemContent(source, item).then(data => {
        this.uploading = false
        if (data.errors) return
        this.$toast({
          message: this.$t('selection.tipSaved'),
          duration: 1500,
          icon: 'fa-check-circle'
        })
        this.$router.push({
          name: 'selection',
          query: {
            bid,
            sid: source,
            tab: 'patch'
          }
        })
      }).catch(e => {
        this.uploading = false
        this.$toast({
          message: this.$t('shelf.saveFailed')
        })
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';

// 骨架图
.skeleton-book {
  pointer-events: none;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-cover {
  width: 130px;
  height: 180px;
  border-radius: 2px 6px 6px 2px;
}

.skeleton-line {
  height: 14px;
  margin-bottom: 10px;
}

.skeleton-title {
  width: 60%;
  height: 18px;
  margin-bottom: 14px;
}

.skeleton-text {
  width: 45%;
  &.short { width: 30%; }
}

.skeleton-btns {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

.skeleton-btn {
  width: 80px;
  height: 32px;
  border-radius: 20px;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (max-width: 767px) {
  .skeleton-cover {
    width: 100px;
    height: 140px;
  }
}

.shelf-page-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: -10%;
    left: -10%;
    width: 45%;
    height: 50%;
    background: radial-gradient(ellipse at center, rgba(200, 180, 240, 0.5) 0%, rgba(180, 210, 255, 0.3) 40%, transparent 70%);
    border-radius: 50%;
    filter: blur(60px);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -10%;
    right: -10%;
    width: 45%;
    height: 50%;
    background: radial-gradient(ellipse at center, rgba(170, 230, 220, 0.42) 0%, rgba(180, 240, 210, 0.22) 40%, transparent 70%);
    border-radius: 50%;
    filter: blur(60px);
  }

  .shelf-bg-tl {
    position: absolute;
    top: -10%;
    left: -10%;
    width: 40%;
    height: 45%;
    background: radial-gradient(ellipse at center, rgba(180, 210, 255, 0.4) 0%, rgba(200, 180, 240, 0.2) 40%, transparent 70%);
    border-radius: 50%;
    filter: blur(60px);
  }

  .shelf-bg-tr {
    position: absolute;
    top: -10%;
    right: -10%;
    width: 40%;
    height: 45%;
    background: radial-gradient(ellipse at center, rgba(180, 240, 220, 0.35) 0%, rgba(170, 230, 210, 0.18) 40%, transparent 70%);
    border-radius: 50%;
    filter: blur(60px);
  }
}

.shelf.container {
  padding: 20px;
  position: relative;
  z-index: 1;

  .action-bar {
    margin-bottom: 1rem;

    button {
      margin-right: .5rem;

      &:hover {
        transform: translateY(-2px);
        box-shadow: $dp-1;
      }
    }
  }

  .patch-modal .modal-content {
    width: 600px;
    max-width: 600px;
  }

  .book-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    margin-top: 1.5rem;
    text-align: left;

    .shelf-row {
      display: flex;
      gap: 1.5rem;
      width: 100%;
      padding-bottom: 1.5rem;
      margin-bottom: 3.5rem;
      position: relative;
      align-items: flex-end;

      // 书架横板
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 8px;
        background: linear-gradient(to bottom, #d1d5db, #b0b5be);
        border-radius: 0 0 3px 3px;
        box-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.2);
      }

      .book {
        flex: 1;
        min-width: 0;
      }

      .book-placeholder {
        flex: 1;
        min-width: 0;
      }

      .promotion-slot {
        flex: 1;
        min-width: 0;
        cursor: pointer;
        padding: 0;
        border: 0;
        background: transparent;
        overflow: hidden;
        align-self: flex-end;
        transition: transform 0.25s;

        &:hover {
          transform: translateY(-2px);
        }

        .promotion-slot__image {
          display: block;
          width: 100%;
          height: auto;
          border-radius: 12px;
        }
      }
    }

    @media screen and (max-width: 768px) {
      .shelf-row {
        flex-direction: column;
        gap: 0;
        padding-bottom: 0;
        margin-bottom: 0;

        // 移动端隐藏整排的横线
        &::after {
          display: none;
        }

        .book-placeholder {
          display: none;
        }

        // 每本书下面加横线
        .book {
          padding-bottom: 1rem;
          margin-bottom: 3rem;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 8px;
            background: linear-gradient(to bottom, #d1d5db, #b0b5be);
            border-radius: 0 0 3px 3px;
            box-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.2);
          }
        }

      }
    }
  }

  .empty-shelf {
    margin-top: 1rem;
  }

  .fade-in-enter-active {
    transition: all 0.5s ease-in-out;
  }

  .fade-in-enter {
    opacity: 0;
    transform: translateX(50px);
  }

  .side-btns {
    position: fixed;
    left: 0;
    bottom: 2em;
    z-index: 10;
    flex-direction: column;

    .btns {
      font-size: 14px;
      display: block;
      width: 2.5em;
      line-height: 1.35;
      white-space: inherit;
      text-align: center;
      padding: .5em;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      transform: translateX(-10%);
      transition: .3s;
      margin-bottom: .5rem;
    }
  }

  .shelf-tabs {
    position: relative;
    width: 100%;
    overflow: hidden;
    margin: 1rem 0;
    text-align: center;

    &__item-wrapper {
      display: inline-block;
    }

    &__item {
      display: inline-block;
      padding: 0 .75em;
      font-weight: 500;
      cursor: pointer;

      &.active {
        color: $el-color-primary;

        &:after {
          content: '';
          display: block;
          height: 2px;
          width: 100%;
          background-color: $el-color-primary;
          margin-top: .5rem;
        }
      }
    }
  }

  .create-book-btn {
    margin-top: 1rem;

    button {
      width: 100%;
      max-width: 240px;
      font-weight: 500;
      font-size: 14px;
      line-height: 2;
      box-shadow: 0 0 3px 2px rgba(245, 99, 104, .25);
    }
  }
}
</style>
